import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";
import { ArrowRight } from "lucide-react";

function Card({ item }) {
  return (
    <div className="blog-card-custom">
      {/* IMAGE SECTION */}
      <Link to={`/blog/${item?.slug}`} className="blog-img-link">
        <div className="blog-img-container">
          <img src={item?.image} alt={item?.title} loading="lazy" className="blog-main-img" />
          {item?.date && (
            <div className="blog-date-sticker">
              {getDateAgo(item?.date)}
            </div>
          )}
        </div>
      </Link>

      {/* OVERLAPPING CONTENT BOX */}
      <div className="blog-content-box">
        <h4 className="blog-card-title">{item?.title}</h4>
        <p className="blog-card-desc">{item?.shortDescription}</p>

        <div className="blog-footer-area">
          <Link to={`/blog/${item?.slug}`} className="read-more-link">
            READ STORY <ArrowRight size={18} className="arrow-move" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Card;